<button type="button" class="btn p-0" (click)="seand()" [disabled]="load">
    <span *ngIf="load" class="spinner-border spinner-border-sm" role="status" ></span>
    <span *ngIf="!load"> {{ 'VERIFICATION_LINK_NOT_RECEIVED' | translate }} </span>
    <span *ngIf="load"> {{ 'RESENDING_MESSAGE' | translate }} </span>
</button>
